export default "__VITE_ASSET__Bh8Q9$0Q__"